// eslint-disable-next-line import/no-extraneous-dependencies
import styled from 'styled-components';
export const FlagContainer = styled.span `
  display: inline-flex;
  flex-shrink: 0;
  width: 1.25rem;
  aspect-ratio: 3 / 2;
  overflow: hidden;
  border-radius: var(--border-radius-sm);
  box-shadow: 0 0 0 1px var(--color-neutral-200);

  svg {
    width: 100%;
    height: 100%;
    display: block;
  }
`;
//# sourceMappingURL=style.js.map